<template>
    <vs-popup classContent="popup-example" :title="translate('AddTemplate')" :active.sync="popUps.popupAddActive">
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" :label="translate('Name')" v-model="formParams.name" :readonly="formParams.formType==='edit'" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" :label="translate('Subject')" v-model="formParams.subject" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-select
              placeholder="Select option"
              class="selectExample mb-2 w-full"
              label="Is file template"
              v-model="formParams.isFileTemplate"
              >
              <vs-select-item :key="index" :value="item" :text="item" v-for="(item,index) in options" />
          </vs-select>
        </div>
      </div>   
      <div class="vx-row mb-6" v-if="formParams.isFileTemplate==='No'">
        <div class="vx-col w-full">
              <vs-textarea label="Html body" v-model="formParams.body" />
        </div>
      </div>  
      <div class="vx-row mb-6" v-if="formParams.isFileTemplate==='Yes'">
        <div class="vx-col w-full">
            <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions" v-on:vdropzone-sending="sendingEvent" v-on:vdropzone-complete="successUpload"></vue-dropzone> 
        </div>
      </div>  
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-button :disabled="formParams.isFileTemplate==='Yes' && formParams.isFileTemplate==='No'" @click="uploadFile()" color="primary" type="filled">{{translate('Save')}}</vs-button>
        </div>
      </div>
    </vs-popup>
</template>
<script>
import axios from "@/axios.js"
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
export default {
    props:['closePopups','formParams','popUps','openAlert'],
    data() {
        return {
          isFileTemplate: true,
          options:['Yes','No'],
          dropzoneOptions: {
              url: '/api/mailers',
              thumbnailWidth: 150,
              maxFilesize: 100,
              paramName: 'document',
              withCredentials: true,
              //headers: {'Content-Type': 'application/x-www-form-urlencoded'},
              autoProcessQueue: false
          },
        }
    },
    components:{
       'vue-dropzone': vue2Dropzone
    },
    methods:{
      translate: function(key){
        return this.$t(key);
      },
      uploadFile: function(){
        this.$refs.myVueDropzone.processQueue();
      },
      sendingEvent (file, xhr, formData) {
        formData.append('type', 'file-upload');
        formData.append('name', this.formParams.name);
        formData.append('subject',this.formParams.subject);
      },
      successUpload(response) {
        let res = JSON.parse(response.xhr.response);
        if(res[0].out1==='done!' || this.successStatuses.indexOf(res[0].out1)!==-1){
          this.$vs.notify({ color: 'success', title: 'Upload Success', text: 'File uploaded' })
          this.reset();
        } else
          this.$vs.notify({ color: 'danger', title: 'Failed', text: res[0].out1 })
      },
      submitForm: function(){
        let that = this;
        this.$validator.validateAll().then(result => {
          if(result) {
            that.addData();
          }
        })
      },
      addData: function(){
        let that = this;
        this.$vs.loading();
        axios.post("/api/mailers",this.formParams)
        .then((data) => {
          that.$vs.loading.close();
          if(data.data.success){
            that.closePopups();
            that.openAlert('success','Success');
            that.componentKey++;
          } else{
            that.openAlert('danger','Failed',data.data.Message);
          }
        })
        .catch(() => { that.$vs.loading.close(); that.openAlert('danger','Failed'); })
      },  
    }
}
</script>